<script>
  import BaseSpinner from '../BaseSpinner/BaseSpinner.svelte';
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import { currentLocation } from '../../utils/location';

  let {
    content,
    loadingText,
    errorText,
    completeText,
    dataTestId = 'detect-location-tile',
    detectedCallback = () => {},
  } = $props();

  let loading = $state();
  let isError = $state();
  let statusText = $state();

  const handleClick = async () => {
    isError = false;
    loading = true;
    statusText = loadingText;
    const location = await currentLocation();
    loading = false;
    if (location) {
      statusText = completeText;
      detectedCallback(location);
    } else {
      isError = true;
      statusText = errorText;
    }
  };
</script>

<button
  class="w-full p-4 flex items-center shadow bg-blue-cerulean text-white hover-hover:hover:bg-blue-darkish
  focus:relative focus:outline-hidden active:shadow-inset-active active:bg-blue-darkish
  focus:bg-blue-darkish focus:shadow-inset-focus"
  disabled={loading}
  data-testid={dataTestId}
  onclick={handleClick}
>
  <div aria-live="polite" aria-label={statusText} data-testid="{dataTestId}-status"></div>
  <div class="mr-4 flex-none">
    {#if loading}
      <BaseSpinner dataTestId="{dataTestId}-spinner" />
    {:else}
      <svg class="h-6 w-6 text-white fill-current" role="presentation">
        <use xlink:href="{SPRITESHEET_URL}#detect" />
      </svg>
    {/if}
  </div>
  <div
    class="text-base text-left font-normal leading-tight"
    class:cursor-default={loading}
    class:cursor-pointer={!loading}
    class:underline={isError}
  >
    {#if isError}
      {errorText}
    {:else if loading}
      {loadingText}
    {:else}
      {@html content}
    {/if}
  </div>
</button>
